import React from 'react';

const GradientHeading = ({ children, style = {}, ...props }) => (
  <h1
    style={{
      fontSize: 32,
      fontWeight: 800,
      marginBottom: 32,
      letterSpacing: '-1px',
      background: 'linear-gradient(90deg, #0a2540 0%, #010101 40%, #fe2c55 100%)',
      WebkitBackgroundClip: 'text',
      WebkitTextFillColor: 'transparent',
      ...style,
    }}
    {...props}
  >
    {children}
  </h1>
);

export default GradientHeading;
